var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-comparison" }, [
    _vm.isInitialized && !_vm.items.length
      ? _c("div", { staticClass: "c-comparison__empty" }, [
          _c("div", { staticClass: "c-msg c-msg--info is-flash" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("Comparison.Table.empty")) +
                "\n        "
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isInitialized && false && _vm.items.length && _vm.types.length > 1
      ? _c(
          "div",
          { staticClass: "c-comparison__header" },
          [
            _vm._v("\n        todo types\n        "),
            _vm._l(_vm.types, function (type, id) {
              return _c("div", { key: id }, [
                _vm._v("\n            type " + _vm._s(type) + "\n        "),
              ])
            }),
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.isInitialized && _vm.items.length
      ? _c("div", { staticClass: "c-comparison__content" }, [
          _c("div", { staticClass: "c-comparison-table js-comparison-table" }, [
            _c(
              "div",
              {
                staticClass:
                  "c-comparison-table__header syncscroll js-comparison-table-header",
                class: { "is-sticky": _vm.isSticky },
                attrs: { name: "comparison-table" },
              },
              [
                _c("div", {
                  staticClass: "c-comparison-table__column is-aside",
                }),
                _vm._v(" "),
                _vm._l(_vm.items, function (item) {
                  return _c(
                    "div",
                    { key: item.id, staticClass: "c-comparison-table__column" },
                    [
                      _c("ComparisonProduct", {
                        attrs: { item: item },
                        on: { remove: _vm.removeItem },
                      }),
                    ],
                    1
                  )
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "c-comparison-table__content syncscroll",
                attrs: { name: "comparison-table" },
              },
              [
                _c(
                  "div",
                  { staticClass: "c-comparison-table__column is-aside" },
                  _vm._l(_vm.properties, function (group, groupId) {
                    return _c("ComparisonGroup", {
                      key: groupId,
                      attrs: { group: group, groupId: groupId },
                    })
                  }),
                  1
                ),
                _vm._v(" "),
                _vm._l(_vm.items, function (item) {
                  return _c(
                    "div",
                    { key: item.id, staticClass: "c-comparison-table__column" },
                    _vm._l(_vm.properties, function (group, groupId) {
                      return _c("ComparisonGroup", {
                        key: groupId,
                        attrs: {
                          "item-id": item.id,
                          group: group,
                          groupId: groupId,
                        },
                      })
                    }),
                    1
                  )
                }),
              ],
              2
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }